var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// componente auxiliar para mensagens do componente Uploader.
import './styles.css';
var UploadMessege = function (props) {
    var color = 'text-gray-message';
    if (props.type === 'success') {
        color = 'text-green-message';
    }
    if (props.type === 'error') {
        color = 'text-red-message';
    }
    return (_jsx("p", __assign({ className: color }, { children: props.children }), void 0));
};
export default UploadMessege;
